/**
 * 模块名称: 导入管理模块
 * @author zhuyan@372163.com
 */

import React from 'react'
import { Switch, Route } from 'react-router-dom'
import Tolead from './Tolead'
import Import from './Import'
import './assets/style.scss'

const ImportDownIndex = ({ match, history }) => {

  return (
    <div>
      <Switch>
        <Route path={match.path + '/import'} component={Import} />
        <Route path={match.path + '/tolead'} component={Tolead} />
        <Route component={Tolead} />
      </Switch>
    </div>
  )
}

export default ImportDownIndex